<template>
  <div id="login">
    <div class="logo">
      <div class="logo-badge" aria-hidden="true">YWHC</div>
      <div>
        <strong>源网荷储系统</strong>
        <span>Source · Grid · Load · Storage Platform</span>
      </div>
    </div>
    <div class="content">
      <span class="title">演示登录</span>
      <span class="demo-label">DEMO · 全功能展示权限</span>
      <div class="demo-credential">演示账号：demo　密码：demo123</div>
      <el-form :model="loginForm" ref="loginForm" :rules="rules" class="login-form" :show-message="false">
        <el-form-item prop="userName">
          <el-input v-model.trim="loginForm.userName" placeholder="请输入用户名"></el-input>
          <img src="../../assets/images/login/user-icon.png" alt="" class="prefix-icon" />
        </el-form-item>
        <el-form-item prop="passWord">
          <el-input v-model.trim="loginForm.passWord" :type="status ? 'text' : 'password'" placeholder="请输入密码"
            maxlength="12"></el-input>
          <img src="../../assets/images/login/password-icon.png" alt="" class="prefix-icon" />
          <div class="suffix-icon" @click="switchStatus">
            <img v-show="!status" src="../../assets/images/login/eyes-close.png" alt="" />
            <img v-show="status" src="../../assets/images/login/eyes-open.png" alt="" />
          </div>
        </el-form-item>

        <el-form-item prop="code">
          <el-input placeholder="请输入验证码" @keydown.enter.native="handleEnterKey" v-model="loginForm.code"
            style="width: 223px">
          </el-input>
          <img src="../../assets/images/login/verification-icon.png" alt="" class="prefix-icon" />
          <span class="verification demo-code">V2DEMO</span>
        </el-form-item>
        <el-form-item>
          <button class="login-submit" @click.prevent="loginSubmit('loginForm')">
            登录
          </button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {
  localDevelopmentMenu,
  localDevelopmentPermissions,
} from "@/mock/localMenu";
export default {
  data() {
    return {
      loginForm: {
        userName: "demo",
        passWord: "demo123",
        code: "V2DEMO",
      },
      status: false,
      rules: {
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        passWord: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 添加模拟登录方法，包含完整权限数据
    mockLogin() {
      // 模拟完整的登录成功后的数据结构，包含权限信息
      const mockUserData = {
        code: 200,
        data: {
          token: "mock-token-" + Date.now(),
          roleInfo: {
            permissions: ["*:*:*"] // 给予所有权限
          },
          menuList: {
            data: [
              {
                id: 1,
                name: "首页",
                path: "/",
                component: "Layout",
                children: []
              },
              {
                id: 2,
                name: "驾驶舱",
                path: "/cockpit",
                component: "Layout",
                children: [
                  {
                    id: 21,
                    name: "电力驾驶舱",
                    path: "electricity",
                    component: "cockpit-electricity"
                  }
                ]
              },
              {
                id: 3,
                name: "日常办公",
                path: "/dailyWork",
                component: "dailyWork",
                children: [
                  {
                    id: 31,
                    name: "意见反馈",
                    path: "feedback",
                    component: "feedback"
                  },
                  {
                    id: 32,
                    name: "消息管理",
                    path: "message",
                    component: "message"
                  }
                ]
              },
              {
                id: 4,
                name: "Control",
                path: "/control",
                component: "control",
                children: []
              },
              {
                id: 5,
                name: "/electricityHome",
                path: "/electricityHome",
                component: "electricityHome",
                children: []
              },
              {
                id: 6,
                name: "事件记录",
                path: "/event",
                component: "Layout",
                children: [
                  {
                    id: 61,
                    name: "操作日志",
                    path: "operation",
                    component: "operation-log"
                  }
                ]
              },
              {
                id: 7,
                name: "用电分析",
                path: "/analysis",
                component: "Layout",
                children: [
                  {
                    id: 71,
                    name: "用能报表",
                    path: "energy",
                    component: "energy-report"
                  }
                ]
              },
              {
                id: 8,
                name: "电力监测",
                path: "/monitor",
                component: "Layout",
                children: [
                  {
                    id: 81,
                    name: "配电图",
                    path: "distribution",
                    component: "distribution"
                  }
                ]
              }
            ]
          },
          userInfo: {
            id: 1,
            username: "demo",
            userName: "demo",
            name: "演示管理员",
            appellation: "演示管理员",
            roles: ["admin"]
          }
        }
      };

      mockUserData.data.menuList.data = localDevelopmentMenu;
      mockUserData.data.roleInfo.permissions = localDevelopmentPermissions;
      
      // 设置会话信息
      sessionStorage.setItem('roleInfo', JSON.stringify(mockUserData.data.roleInfo.permissions));
      sessionStorage.setItem("lc_token", mockUserData.data.token);
      
      // 处理菜单列表和特殊权限
      mockUserData.data.menuList.data.forEach(item=>{
        if(item.name=="Control"){
          sessionStorage.setItem("getControl", JSON.stringify(item));
          this.$store.commit("getControl", item);
        }
        if(item.name=="Document" || item.path=="/dailyWork"){
          if(item.children && item.children.length > 0){
            let arrList=item.children.map(arr=>arr.path)
            if(arrList.includes('/dailyWork/message') || arrList.includes('message')){
              sessionStorage.setItem("message", 0);
            }else{
              sessionStorage.setItem("message", 1);
            }
          }else{
            sessionStorage.setItem("message", 1);
          }
        }
        if(item.name=="/electricityHome"){
          sessionStorage.setItem("electricityHome", JSON.stringify(item));
        }
      });
      
      sessionStorage.setItem("menu_list", JSON.stringify(mockUserData.data.menuList.data));
      sessionStorage.setItem("user_info", JSON.stringify(mockUserData.data.userInfo));
      this.$store.commit("updateMenuList", mockUserData.data.menuList.data);
      this.$store.commit("updateUserInfo", mockUserData.data.userInfo);
      const redirect = typeof this.$route.query.redirect === "string"
        ? this.$route.query.redirect
        : "/home";
      this.$router.replace(redirect === "/" ? "/home" : redirect);
    },
    
    switchStatus() {
      this.status = !this.status;
    },
    handleEnterKey() {
      this.loginSubmit('loginForm')
    },
    loginSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.$message.warning("请完整填写演示账号、密码和验证码");
          return;
        }
        const code = String(this.loginForm.code || "").trim().toUpperCase();
        if (
          this.loginForm.userName !== "demo" ||
          this.loginForm.passWord !== "demo123" ||
          code !== "V2DEMO"
        ) {
          this.$message.error("演示账号、密码或验证码不正确");
          return;
        }
        this.mockLogin();
      });
    },
    transformData(data) {
      data.forEach(item => {
        if (item.children && item.children.length > 0) {
          const type2Menus = item.children.filter(child => {
            if (child.type === 2) {
              return child
            }
          });
          if (type2Menus.length > 0) {
            item.authority = []
            type2Menus.reduce((acc, cur) => {
              if (cur.children && cur.children.length > 0) {
                acc.push(...cur.filter(child => child.code).map(child => child.code));
              }
              item.authority.push(cur.code)
            }, item.authority || []);
            item.children = item.children.filter(child => child.type !== 2);
          }
        }
        if (item.children && item.children.length > 0) {
          this.transformData(item.children);
        }
      });
      return data;
    }
  },
};
</script>
<style scoped>
#login {
  width: 100%;
  height: 100vh;
  background: url(../../assets/images/login/background.jpg) no-repeat center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  color: #eef7ff;
}

.logo-badge {
  width: 0.66rem;
  height: 0.58rem;
  box-sizing: border-box;
  border: 1px solid rgba(58, 222, 255, 0.8);
  border-radius: 0.08rem;
  background: linear-gradient(135deg, rgba(15, 62, 143, 0.95), rgba(4, 22, 67, 0.95));
  box-shadow: inset 0 0 0 1px rgba(86, 147, 255, 0.22), 0 0 0.22rem rgba(21, 185, 255, 0.25);
  color: #6ae9ff;
  font-size: 0.15rem;
  font-family: Consolas, monospace;
  font-weight: 700;
  line-height: 0.58rem;
  letter-spacing: 0.02rem;
  text-align: center;
}

.logo > div {
  display: flex;
  flex-direction: column;
  margin-left: 0.18rem;
}

.logo strong {
  font-size: 0.38rem;
  line-height: 0.46rem;
  letter-spacing: 0.08rem;
}

.logo span {
  margin-top: 0.04rem;
  color: rgba(202, 225, 255, 0.72);
  font-size: 0.13rem;
  letter-spacing: 0.07rem;
}

.content {
  width: 10.38rem;
  height: 5.25rem;
  background: url(../../assets/images/login/form.png) no-repeat center;
  background-size: cover;
  margin-top: 0.4rem;
  position: relative;
}

.title {
  font-size: 0.26rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #f1f9ff;
  position: absolute;
  right: 0.82rem;
  top: 0.62rem;
  width: 3.43rem;
  text-align: center;
}

.demo-credential {
  position: absolute;
  right: 0.82rem;
  top: 1.13rem;
  width: 3.43rem;
  color: rgba(145, 207, 255, 0.8);
  font-size: 0.12rem;
  text-align: right;
}

.demo-label {
  position: absolute;
  right: 0.82rem;
  top: 0.96rem;
  width: 3.43rem;
  color: #4adcf8;
  font-size: 0.11rem;
  letter-spacing: 0.03rem;
  text-align: right;
}

.login-form {
  width: 3.43rem;
  position: absolute;
  right: 0.82rem;
  top: 1.35rem;
}

.login-form :deep() .el-input__inner {
  background-color: rgba(37, 79, 184, 0.11);
  border: 0;
  height: 0.57rem;
  color: #b7c8ff;
  font-size: 0.16rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  padding: 0 0.6rem;
  position: relative;
}

.prefix-icon {
  width: 0.21rem;
  position: absolute;
  top: 0.18rem;
  left: 0.16rem;
}

.suffix-icon {
  line-height: 0;
  position: absolute;
  right: 0.23rem;
  top: 0.18rem;
}

.suffix-icon img {
  width: 0.2rem;
}

.verification {
  width: 1.04rem;
  position: absolute;
  top: 0;
  right: 0;
}

.demo-code {
  height: 0.57rem;
  box-sizing: border-box;
  border: 1px solid rgba(53, 205, 255, 0.38);
  background: rgba(8, 43, 104, 0.76);
  color: #62e8ff;
  font-size: 0.16rem;
  font-family: Consolas, monospace;
  font-weight: 700;
  letter-spacing: 0.06rem;
  line-height: 0.55rem;
  text-align: center;
  text-indent: 0.06rem;
  user-select: none;
}

.login-submit {
  width: 100%;
  height: 0.6rem;
  background: #122b7d;
  border-radius: 0.06rem;
  border: 0;
  font-size: 0.2rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #e7e9fe;
  line-height: 0.6rem;
}

.login-form :deep() .el-input__inner:-webkit-autofill {
  -webkit-box-shadow: 0px 0px 0px 30px #0e153e inset;
  -webkit-text-fill-color: #b7c8ff;
  border-radius: 0;
}

.login-form :deep() .el-input input::placeholder {
  font-size: 0.16rem;
  color: #6180a8;
}
</style>
